module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C143"
  }, [_c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARQUIS OF")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSSIE")])]), _vm._v(" "), _c('p', {
    staticClass: "C162"
  }, [_vm._v("1877")]), _vm._v(" "), _c('p', {
    staticClass: "C163"
  }, [_vm._v("The Cullen Collection")]), _vm._v(" "), _c('p', {
    staticClass: "C164"
  }, [_vm._v("Volume 20")]), _vm._v(" "), _c('p', {
    staticClass: "C108"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "auto",
      "src": "Images/image00223.jpeg",
      "width": "61%"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b9bc8dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0010.vue
// module id = 87
// module chunks = 0